import { render, staticRenderFns } from "./DualButtonModal.vue?vue&type=template&id=2d4c73ba&scoped=true"
import script from "./DualButtonModal.vue?vue&type=script&lang=js"
export * from "./DualButtonModal.vue?vue&type=script&lang=js"
import style0 from "./DualButtonModal.vue?vue&type=style&index=0&id=2d4c73ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4c73ba",
  null
  
)

export default component.exports